import { Link, useRouterState } from '@tanstack/react-router';
import { cn } from '@jeraisonne/ui';

const TABS = [
  { id: 'reservations', label: 'Agenda', to: '/tutor/rendez-vous' },
  { id: 'creneaux', label: 'Créneaux', to: '/tutor/rendez-vous/creneaux' },
  { id: 'series', label: 'Séries', to: '/tutor/rendez-vous/series' },
  { id: 'paiements', label: 'Paiements', to: '/tutor/rendez-vous/paiements' },
] as const;

export function TutorBookingTabs() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    // 4 onglets qui tiennent sur 375 px (avant : « Paiements » coupé hors écran).
    <nav
      aria-label="Rendez-vous"
      className="border-ink-200 -mx-4 mb-5 flex border-b px-2 sm:-mx-6 sm:justify-start sm:gap-1 sm:px-6"
    >
      {TABS.map((tab) => {
        const active =
          tab.id === 'reservations'
            ? pathname === '/tutor/rendez-vous' || pathname === '/tutor/rendez-vous/'
            : pathname.startsWith(tab.to);
        return (
          <Link
            key={tab.id}
            to={tab.to}
            aria-current={active ? 'page' : undefined}
            className={cn(
              'font-display relative inline-flex min-h-[2.75rem] flex-1 items-center justify-center px-1 text-sm font-semibold transition-colors sm:flex-none sm:px-4',
              active ? 'text-primary-700' : 'text-ink-500 hover:text-ink-800',
            )}
          >
            {tab.label}
            {active && (
              <span className="bg-primary-500 absolute inset-x-2 -bottom-px h-0.5 rounded-full" />
            )}
          </Link>
        );
      })}
    </nav>
  );
}
